<template>
  <v-container>
    <div>
      <v-container>
        <h2>Filtro asociado</h2>
        <v-row>
          <!-- {{ this.pages[selectedPage] }} -->
          <!-- {{ this.pages[selectedPage].item_list }} -->
          <v-select
            :items="filtrosRelacionados"
            item-text="name"
            label="Select an Item"
            v-model="selectedItem.filtroAsociado"
            return-object
          ></v-select>
          <!-- </v-col> -->
        </v-row>
      </v-container>
      <v-container>
        <h2>Estilo</h2>
        <v-text-field
          label="Clase"
          v-model="inputCopy.customized.class"
        >
        </v-text-field>
        <v-textarea
          v-model="inputCopy.customized.css"
          label="Escribe el estilo"
          outlined
        ></v-textarea>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
// import moment from 'moment';
export default {
  data() {
    return {
      inputCopy: null,
      dateFormatted: null,
      // selectedItem: { id: 1, texto: "Hora" },
      options: [
        { id: 1, texto: "Hora" },
        { id: 2, texto: "Fecha completa" },
      ],
    };
  },
  computed: {
    ...mapState(["selectedItem", "pages", "selectedPage"]),

    filtrosRelacionados() {
      return this.pages[this.selectedPage].item_list.filter((el) => {
        return el.settings.component_name === "filtro-entre-fechas";
      });
    },
  },

  mounted() {
    this.inputCopy = this.selectedItem;
    console.group("DATOS DEL ELEMENTO SELECCIONADO");
    console.log(this.selectedItem);
    console.groupEnd();
  },

  methods: {
    //methodos
    addEmptyState() {
      this.selectedItem.customized.estados.push({
        nombre: "??",
        color: "#FFFFFF",
        valor: this.selectedItem.customized.estados.length + 1,
      });
    },
  },
};
</script>

<style scoped>
.color-square {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.style-estado {
  display: flex;
  align-items: center; /* Centra verticalmente los elementos */
}
/* Asegúrate de que el drawer ocupe todo el alto de la ventana */
.v-navigation-drawer {
  height: 100vh; /* Altura completa del viewport */
  top: 64px; /* Desplazamiento desde la parte superior */
  max-height: calc(100% - 64px); /* Ajusta la altura máxima teniendo en cuenta el desplazamiento */
  width: 300px; /* Ancho del drawer */
  overflow-y: auto; /* Permite el desplazamiento vertical si el contenido es más grande que el contenedor */
}

/* Contenedor principal del drawer */
.v-navigation-drawer__content {
  padding: 16px; /* Espaciado interno */
}

/* Estilos para los encabezados */
h2 {
  margin: 0 0 16px 0; /* Margen inferior para separación */
}

/* Estilo de los botones */
.v-btn {
  margin-bottom: 16px; /* Espacio inferior para separación entre botones y otros elementos */
}

/* Estilo para los inputs */
.v-input__control {
  margin-bottom: 16px; /* Espacio inferior para separación entre campos de entrada */
}

/* Flexbox para el contenedor de estados */
.style-estados-container {
  display: flex;
  align-items: center; /* Alinear verticalmente en el centro */
  gap: 10px; /* Espacio entre elementos */
  flex-wrap: nowrap; /* Evita el ajuste de línea para mantener todos los elementos en una línea */
}

/* Estilos específicos para cada tipo de input */
.style-estados-checkbox {
  flex-shrink: 0; /* Evita que el checkbox se reduzca */
}

.style-estados-label {
  flex: 1; /* Permite que el input de texto use el espacio restante */
  max-width: 80px; /* Limita el ancho máximo del input de texto */
}

.style-estados-value {
  width: 50px; /* Asigna un ancho fijo al input numérico */
  flex-shrink: 0; /* Evita que el input numérico se reduzca */
}

.style-estados-color {
  width: 30px; /* Asigna un ancho fijo al input de color */
  height: 30px; /* Asigna una altura fija al input de color */
  border: none; /* Elimina cualquier borde */
  padding: 0; /* Elimina padding */
  cursor: pointer; /* Cambia el cursor a mano */
  margin-top: -6px; /* Centra el input de color horizontalmente dentro de su columna */
}
</style>
